import { render, staticRenderFns } from "./MediaManagement.vue?vue&type=template&id=76120ae2&scoped=true"
import script from "./MediaManagement.vue?vue&type=script&lang=js"
export * from "./MediaManagement.vue?vue&type=script&lang=js"
import style0 from "./MediaManagement.vue?vue&type=style&index=0&id=76120ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76120ae2",
  null
  
)

export default component.exports